<template>
  <div class="configuration">
    <v-card>
      <v-card-text ref="container">
        <v-row>
          <v-col>
              <v-textarea auto-grow="1" filled outlined value="

                questions: [
                    {
                      code: 'CPIT-0100',
                      name: 'Catchpit Type',
                      type: 'radio',
                      order: '100',
                      answers: [
                        {
                          code: 'single_cesspit',
                          name: 'Single Cesspit',
                          next_step: 'CPIT-0200'
                        },
                        {
                          code: 'double_cesspit',
                          name: 'Double Cesspit',
                          next_step: 'CPIT-0200'
                        },
                        {
                          code: 'street_super_single',
                          name: 'Street / Super Pit Single',
                          next_step: 'CPIT-0200'
                        },
                        {
                          code: 'street_super_double',
                          name: 'Street / Super Pit Double',
                          next_step: 'CPIT-0200'
                        },
                        {
                          code: 'splay_pit',
                          name: 'Splay Pit',
                          next_step: 'CPIT-0350'
                        },
                        {
                          code: 'mega_pit',
                          name: 'Mega Pit',
                          next_step: 'CPIT-0200'
                        }
                      ]
                    },
                    {
                      code: 'CPIT-0200',
                      name: 'Insert Type',
                      type: 'radio',
                      order: '200',
                      answers: [
                        {
                          code: 'enviropod',
                          name: 'Enviropod',
                          next_step: 'CPIT-0300'
                        },
                        {
                          code: 'tetratrap',
                          name: 'Tetratrap',
                          next_step: 'CPIT-0300'
                        },
                        {
                          code: 'none',
                          name: 'None',
                          next_step: 'CPIT-0300'
                        }
                      ]
                    },
                    {
                      code: 'CPIT-0300',
                      name: 'Successful Clean',
                      type: 'radio',
                      order: '300',
                      answers: [
                        {
                          code: 'yes',
                          name: 'Yes',
                          next_step: 'CPIT-0400'
                        },
                        {
                          code: 'no',
                          name: 'No',
                          next_step: 'CPIT-0500'
                        }
                      ]
                    },
                    {
                      code: 'CPIT-0350',
                      name: 'Successful Clean',
                      type: 'radio',
                      order: '350',
                      answers: [
                        {
                          code: 'yes',
                          name: 'Yes',
                          next_step: 'CPIT-0450'
                        },
                        {
                          code: 'no',
                          name: 'No',
                          next_step: 'CPIT-0450'
                        }
                      ]
                    },
                    {
                      code: 'CPIT-0400',
                      name: 'Condition Statement',
                      type: 'radio',
                      order: '400',
                      answers: [
                      {
                        code: 'condition_good',
                        name: 'Good',
                        next_step: 'CPIT-0600'
                      },
                        {
                          code: 'grate_blocked',
                          name: 'Grate Blocked',
                          next_step: 'CPIT-0600'
                        },
                        {
                          code: 'back_entry_blocked',
                          name: 'Back Entry Blocked',
                          next_step: 'CPIT-0600'
                        }
                      ]
                    },
                    {
                      code: 'CPIT-0450',
                      name: 'Condition Statement',
                      type: 'radio',
                      order: '450',
                      answers: [
                      {
                        code: 'entry_clear',
                        name: 'Entry Clear',
                        next_step: 'CPIT-0650'
                      },
                        {
                          code: 'entry_blocked',
                          name: 'Entry Blocked',
                          next_step: 'CPIT-0650'
                        }
                      ]
                    },
                    {
                      code: 'CPIT-0500',
                      name: 'Why Not?',
                      type: 'radio',
                      order: '500',
                      answers: [
                        {
                          code: 'unable_to_open',
                          name: 'Unable To Open',
                          next_step: 'END'
                        },
                        {
                          code: 'cannot_reach_pit',
                          name: 'Cannot Reach Pit',
                          next_step: 'END'
                        },
                        {
                          code: 'car_over_pit',
                          name: 'Car Over Pit',
                          next_step: 'END'
                        },
                        {
                          code: 'eviropod',
                          name: 'Enviropod',
                          next_step: 'END'
                        },
                        {
                          code: 'high_traffic_flow',
                          name: 'High Traffic Flow',
                          next_step: 'END'
                        },
                        {
                          code: 'lid_bolted_down',
                          name: 'Lid Bolted Down',
                          next_step: 'END'
                        },
                        {
                          code: 'not_normal_pit',
                          name: 'Not Normal Pit',
                          next_step: 'END'
                        },
                        {
                          code: 'road_works',
                          name: 'Road Works',
                          next_step: 'END'
                        },
                        {
                          code: 'rubbish_in_pit',
                          name: 'Rubbish in Pit',
                          next_step: 'END'
                        },
                        {
                          code: 'scruffy_dome',
                          name: 'Scruffy Dome',
                          next_step: 'END'
                        },
                        {
                          code: 'splay_pit',
                          name: 'Splay Pit',
                          next_step: 'END'
                        },
                        {
                          code: 'megapit',
                          name: 'Megapit',
                          next_step: 'END'
                        }
                      ]
                    },
                    {
                      code: 'CPIT-0600',
                      name: 'Record Any Faults',
                      type: 'checkbox',
                      order: '600',
                      next_step: 'END',
                      answers: [
                        {
                          code: 'blocked_lead',
                          name: 'Blocked Lead'
                        },
                        {
                          code: 'broken_missing_back_plate',
                          name: 'Broken / Missing Back Plate'
                        },
                        {
                          code: 'broken_displaced_grate',
                          name: 'Broken / Displaced Grate'
                        },
                        {
                          code: 'grate_in_sump',
                          name: 'Grate In Sump'
                        },
                        {
                          code: 'no_back_entry',
                          name: 'No Back Entry'
                        },
                        {
                          code: 'no_base',
                          name: 'No Base'
                        },
                        {
                          code: 'no_sump',
                          name: 'No Sump'
                        }
                      ]
                    },
                    {
                      code: 'CPIT-0650',
                      name: 'Record Any Faults',
                      type: 'checkbox',
                      order: '650',
                      next_step: 'END',
                      answers: [
                        {
                          code: 'blocked_lead',
                          name: 'Blocked Lead'
                        },
                        {
                          code: 'no_base',
                          name: 'No Base'
                        },
                        {
                          code: 'no_sump',
                          name: 'No Sump'
                        }
                      ]
                    }
                  ]

              "></v-textarea>

          </v-col>
          <v-btn block light x-large disabled @click="back">SAVE</v-btn>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  methods: {

  }
};
</script>

<style lang="scss">
.configuration {
  height: 100%;

  .v-card {
    height: 100%;

    .v-card__text {
      height: 100%;
    }
  }

}
</style>
